import * as React from "react";
import styled from "styled-components";
import { Spinner } from "components/common";
import { useGetSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { securityEventDetailsAttributes } from "security-app/components/SecurityEvents/Alerts/Constants";
import ActionsRow from "./ActionsRow";
import EventDetails from "./EventDetails";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
`;
function Index({ securityEventId, orientation = "horz", detailsAttributes = securityEventDetailsAttributes }) {
  const { securityEvent, loadingSecurityEvents } = useGetSecurityEvent(securityEventId);
  if (loadingSecurityEvents) {
    return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event..." }));
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ActionsRow, { securityEvent, orientation }), /* @__PURE__ */ React.createElement(EventDetails, { securityEvent, orientation, detailsAttributes }));
}
export default Index;
